'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../../_tslib-15827112.js');
var BaseController = require('../BaseController.js');

var ReimbursementsController = /** @class */ (function (_super) {
    _tslib.__extends(ReimbursementsController, _super);
    function ReimbursementsController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.basePath = "/Reimbursement";
        return _this;
    }
    ReimbursementsController.prototype.Get = function () {
        return _tslib.__awaiter(this, void 0, void 0, function () {
            var endpoint, items;
            return _tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        endpoint = this.basePath + "/" + this.config.countryCode;
                        return [4 /*yield*/, this.MakeRequest({
                                url: endpoint
                            })];
                    case 1:
                        items = _a.sent();
                        return [2 /*return*/, items.map(function (item) { return (_tslib.__assign(_tslib.__assign({}, item), { created: new Date(item.created), reimbursementInfo: JSON.parse(item.reimbursementInfo) })); })];
                }
            });
        });
    };
    ReimbursementsController.prototype.PostGiftCard = function (amount, retailerId, _a) {
        var email = _a.email, phone = _a.phone, donation = _a.donation;
        var endpoint = this.basePath + "/GiftCard";
        var payload = {
            country: this.config.countryCode,
            amount: amount,
            reimbursementInfo: {
                Logo: retailerId.toString(),
                email: email,
                phone: phone,
                donation: donation,
            },
        };
        return this.MakeRequest({
            method: "POST",
            url: endpoint,
            data: payload
        });
    };
    ReimbursementsController.prototype.PostBizum = function (amount, phoneNumber) {
        var endpoint = this.basePath + "/Bizum";
        var payload = {
            country: this.config.countryCode,
            amount: amount,
            reimbursementInfo: {
                phone: phoneNumber,
            }
        };
        return this.MakeRequest({
            method: "POST",
            url: endpoint,
            data: payload,
        });
    };
    ReimbursementsController.prototype.PostVerse = function (amount, phoneNumber) {
        var endpoint = this.basePath + "/Verse";
        var payload = {
            country: this.config.countryCode,
            amount: amount,
            reimbursementInfo: {
                phone: phoneNumber,
            }
        };
        return this.MakeRequest({
            method: "POST",
            url: endpoint,
            data: payload,
        });
    };
    ReimbursementsController.prototype.PostPaypal = function (amount, email) {
        var endpoint = this.basePath + "/Paypal";
        var payload = {
            country: this.config.countryCode,
            amount: amount,
            reimbursementInfo: { email: email }
        };
        return this.MakeRequest({
            method: "POST",
            url: endpoint,
            data: payload,
        });
    };
    ReimbursementsController.prototype.PostBank = function (amount, fullName, iban, address) {
        var endpoint = this.basePath + "/Bank";
        var payload = {
            country: this.config.countryCode,
            amount: amount,
            reimbursementInfo: {
                fullName: fullName,
                iban: iban,
                address: address
            }
        };
        return this.MakeRequest({
            method: "POST",
            url: endpoint,
            data: payload
        });
    };
    ReimbursementsController.prototype.GetLastIban = function () {
        var endpoint = this.basePath + "/" + this.config.countryCode + "/LastIBAN";
        return this.MakeRequest({
            url: endpoint
        });
    };
    return ReimbursementsController;
}(BaseController.default));

exports.default = ReimbursementsController;
//# sourceMappingURL=ReimbursementsController.js.map
